<template>
    <div class="">
        <div class="h-crumbOut">
            <div class="h-crumbs">
                <el-breadcrumb separator="|">
                    <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                    <el-breadcrumb-item><a href="/">项目管理</a></el-breadcrumb-item>
                    <el-breadcrumb-item><a href="/">盈利测算</a></el-breadcrumb-item>
                </el-breadcrumb>
            </div>    
        </div>
        <div class="h-piece y-h">
            <div class="h-pieceIn2">
                <div class="h-pieceTitle2">
                    <h1>项目信息</h1>
                </div>
                <div class="h-pieceCon2 y-b">
                    <div class="h-formLine ">
                        <el-form :model="formLabelAlign" label-position="right"  :inline="true"  class="demo-ruleForm h-formbLine">
                        <el-form-item label="项目名称" class="h-elformWrap-2" >
                            <el-input v-model="formLabelAlign.Name" placeholder="自带出"></el-input>
                        </el-form-item>
                        <el-form-item label="投标方式" class="h-elformWrap-2 y-biao" >
                            <el-input v-model="formLabelAlign.fangshi" placeholder="请选择"></el-input>
                        </el-form-item>
                       <el-form-item label="开标日期" class="h-elformWrap-2 y-kai">
                            <el-select v-model="formLabelAlign.type" placeholder="请选择">
                                <el-option label="类型一" value="type1"></el-option>
                                <el-option label="类型二" value="type2"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="保修期" class="h-elformWrap-2 y-xiu">
                            <div class=" block"> 
                                <el-date-picker
                                    v-model="formLabelAlign.expectConvertDate"
                                    type="date"
                                    placeholder="--选择--"
                                    value-format="yyyy-MM-dd" 
                                    :clearable=false
                                >
                                </el-date-picker>
                            </div>
                        </el-form-item>
                        <el-form-item label="付款方式" class="h-elformWrap-1" style="margin-left:-20px;">
                            <el-input class="input" v-model="formLabelAlign.contactInfo" placeholder="请输入   %(预付)" style="width:200px;"></el-input>
                            <el-input class="input" v-model="formLabelAlign.contactInfo" placeholder="请输入   %(首款)" style="width:200px;margin: 0 20px;"></el-input>
                            <el-input class="input3" v-model="formLabelAlign.contactInfo" placeholder="请输入   %(中款)" style="width:200px;margin-right: 20px;"></el-input>
                            <el-input class="input4" v-model="formLabelAlign.contactInfo" placeholder="请输入   %(尾款)" style="width:200px;"></el-input>
                        </el-form-item>
                        <br>
                        <el-form-item label="账期" class="h-elformWrap-1" style="margin-left:-20px;">
                            <el-input  placeholder="请输入   天(预付)" style="width:200px;"></el-input>
                            <el-input  placeholder="请输入   天(预付)" style="width:200px;margin: 0 20px;"></el-input>
                            <el-input  placeholder="请输入   天(预付)" style="width:200px;margin-right: 20px;"></el-input>
                            <el-input  placeholder="请输入   %(预付)" style="width:200px;"></el-input>
                        </el-form-item>
                        <br>
                       <el-form-item label="项目背景" class="h-elformWrap-2">
                            <el-input v-model="formLabelAlign.beijing" placeholder="请输入" style="margin-bottom:15px;"></el-input>
                            <el-input v-model="formLabelAlign.beijing1" placeholder=""></el-input>
                        </el-form-item>
                        <br>
                        <el-form-item label="专营商毛利率" class="h-elformWrap-2 y-mao" >
                            <el-input v-model="formLabelAlign.contactInfo" placeholder="公式计算"></el-input>
                        </el-form-item>
                        </el-form>
                    </div>
                </div>
            </div>
        </div>
        <div class="h-table" style=" margin: 20px 20px 0 20px">
            <el-table
                :data="tableData"
                :span-method="objectSpanMethod"
                border
                >
                <el-table-column
                prop="message"
                label="分类"
                width="180">
            </el-table-column>
            <el-table-column
                prop="coding"
				:show-overflow-tooltip="true"
                label="科目">
            </el-table-column>
            <el-table-column
                prop="shuoming"
				:show-overflow-tooltip="true"
                label="说明">
            </el-table-column>
            <el-table-column
                prop="biaozhun"
                label="标准/单台">
            </el-table-column>
            <el-table-column
                prop="hejiL"
                label="合计-率">
            </el-table-column>
            <el-table-column
                prop="hejiE"
                label="合计-额">
            </el-table-column>
            <el-table-column
                prop="xinghao"
                label="型号">
            </el-table-column>
            </el-table>
        </div>
        <div class="uninclude">
            <el-form :model="formLabelAlign"   :inline="true"  class="demo-ruleForm h-formbLine">
                <el-form-item label="订单总收入(不含税)" class="h-elformWrap-2" style="text-align:left;">
                    <el-input  v-model="formLabelAlign.contactInfo" placeholder="公式计算" style="width:5rem;"></el-input>
                </el-form-item>
                <el-form-item label="盈亏平衡(含税价)" class="h-elformWrap-2" style="text-align:right">
                    <el-input  v-model="formLabelAlign.contactInfo" placeholder="公式计算" style="width:5rem;"></el-input>
                </el-form-item>
            </el-form>
        </div>
        <div class="xia">
            <el-row>
                <el-button class="h-btn h-bBtn h-bgwhite">返回</el-button>
                <el-button class=" h-btn h-bBtn h-bggreen">暂存</el-button>
                <el-button class="h-btn h-bBtn h-bgblue2">确认提交</el-button>
            </el-row>
        </div>
    </div>
</template>
<style scoped>
    .y-h{
        height: 340px;
        margin: 0 20px 0 20px;
    }
    .y-mao{
        position: relative;
        top: -82px;
        left: 365px;
    }
    .y-b .el-form-item__content .el-select{
         width: 65%;
    }
    .y-b .el-form-item__content .el-input{
        width: 65%;
    }
    .xia{
        margin-left: 400px;
        margin-top: 60px;
    }
    .uninclude{
        padding:20px 0 0 40px;
        margin: 0 20px 0 20px;
        background-color: #fff;
        height: 1rem;
    }
    .bigDiv{
        margin:0 20px;
    }
    .h-crumbOut{
        margin-bottom: 20px;
    }
   
</style>
<style>
    .uninclude .h-formbLine .el-form-item__content{
        width: 71%;
    }
    .uninclude .h-formbLine .el-form-item__label{
        width: 29%;
    }
    .y-b .h-formbLine .h-elformWrap-1 .el-form-item__label{
        width: 11.8%;
    }
    .y-b .h-formbLine .h-elformWrap-1 .el-form-item__content{
        width: 87.8%;
    }
    .y-b .h-formbLine .el-form-item__label{
        width: 21%;
    }
</style>
    
<script>
export default {
    data(){   
        return{
            value3:36,
            //   横向的相关数据
            tableData: [{
                message: '基本信息',
                coding: '编码',
                shuoming:'-',
                biaozhun: '-',
                hejiL: '-',
                hejiE:'-',
                xinghao:'BEOFOEO1T'
            }, 
            {
                coding: '型号',
                biaozhun: '-',
                shuoming:'-',
                hejiL: '-',
                hejiE:'-',
                xinghao:'DW-86L828J',
            }, 
            {
                coding: '产品大类',
                biaozhun: '-',
                shuoming:'-',
                hejiL: '-',
                hejiE:'-',
                xinghao:'超低温',
            }, 
            {
                coding: '产品系列',
                biaozhun: '-',
                shuoming:'-',
                hejiL: '-',
                hejiE:'-',
                xinghao:'-86℃低温保存箱',
            }, 
            {
                message: '收入',
                coding: '终端成交价',
                biaozhun: '-',
                shuoming:'-',
                hejiL: '-',
                hejiE:'51,000',
                xinghao:'51,000',
            },
            {
                message: '收入',
                coding: '单台一级供价',
                biaozhun: '-',
                shuoming:'-',
                hejiL: '-',
                hejiE:'51,000',
                xinghao:'51,000',
            },
            {
                coding: '折扣率',
                biaozhun: '-',
                shuoming:'-',
                hejiL: '51%',
                hejiE:'51%',
                xinghao:'51%',
            },
            {
                coding: '销量',
                biaozhun: '-',
                shuoming:'-',
                hejiL: '-',
                hejiE:'5',
                xinghao:'5|',
            },
            {
                coding: '申请单价(含税)',
                biaozhun: '-',
                shuoming:'-',
                hejiL: '-',
                hejiE:'26,000',
                xinghao:'26,000',
            },
            {
                coding: '订单金额',
                biaozhun: '-',
                shuoming:'-',
                hejiL: '-',
                hejiE:'130,000',
                xinghao:'130,000',
            },
            {
                coding: '不含税订单收入',
                biaozhun: '-',
                shuoming:'-',
                hejiL: '-',
                hejiE:'115.044',
                xinghao:'115.044'
            },
            {
                coding: '盈亏平衡含税价',
                biaozhun: '-',
                shuoming:'-',
                hejiL: '-',
                hejiE:'115.044',
                xinghao:'115.044'
            },
            {
                message: '盈利情况',
                coding: '材料毛利',
                shuoming:'-',
                biaozhun: '-',
                hejiL: '-',
                hejiE:'115.044',
                xinghao:'115.044'
            },
            {
                coding: '经营贡献',
                biaozhun: '-',
                shuoming:'-',
                hejiL: '-',
                hejiE:'115.044',
                xinghao:'115.044'
            },
            {
                coding: '利润',
                biaozhun: '-',
                shuoming:'-',
                hejiL: '-',
                hejiE:'115.044',
                xinghao:'115.044'
            },
            {
                message:'毛利',
                coding: '单台成本',
                shuoming:'测算当月BOM成本',
                biaozhun: '-',
                hejiL: '-',
                hejiE:'115.044',
                xinghao:'115.044'
            },
            {
                coding: '成本合计',
                biaozhun: '-',
                shuoming:'-',
                hejiL: '-',
                hejiE:'115.044',
                xinghao:'115.044'
            },
            {
                coding: '毛利',
                biaozhun: '-',
                shuoming:'-',
                hejiL: '-',
                hejiE:'115.044',
                xinghao:'115.044'
            },
            {
                coding: '材料毛利率',
                biaozhun: '-',
                hejiL: '-',
                shuoming:'-',
                hejiE:'115.044',
                xinghao:'115.044'
            }
            ,
            {
                message:'直接费用',
                coding: '附加成本',
                biaozhun: '-',
                shuoming:'-',
                hejiL: '-',
                hejiE:'115.044',
                xinghao:'115.044'
            },
            {
                coding: '中标服务费',
                biaozhun: '-',
                shuoming:'-',
                hejiL: '-',
                hejiE:'115.044',
                xinghao:'115.044'
            }],
            formLabelAlign: {
                name: '',
                contact:'',
                contactInfo:'',
                type: '',
                date3: '',
                explain:'',
                Name:'', 
                fangshi:'', 
                beijing:'', 
                beijing1:'',
            },
        };
    },
    methods: {
    //   arraySpanMethod({ row, column, rowIndex, columnIndex }) {
    //     if (rowIndex % 3 === 0) {
    //         if (columnIndex === 0) {
    //             return [1, 4];
    //         } else if (columnIndex === 1) {
    //             return [0, 0];
    //         }
    //     }
    //   },

      objectSpanMethod({ row, column, rowIndex, columnIndex }) {
        if (columnIndex === 0) {
            if (rowIndex === 0) {
                return {
                rowspan: 4,
                colspan: 1
                };
            }else if (rowIndex === 4) {  // 当第7行就为正常的一行；要返回 把1行合并为一列
                return {
                    rowspan: 8,
                    colspan: 1
                };
            } else if(rowIndex === 12){
                return {
                    rowspan: 3,
                    colspan: 1
                }
            }else if(rowIndex === 15){
                return {
                    rowspan: 4,
                    colspan: 1
                }
            }else if(rowIndex === 19){
                    return {
                    rowspan: 2,
                    colspan: 1
                    }
            }else{
                return {
                    rowspan: 0,
                    colspan: 0
                }
            }
        }
        if(columnIndex === 1){
            if (rowIndex === 20) {
                return {
                    rowspan: 2,
                    colspan: 1
                };
            }else if(rowIndex === 21){
                return {
                rowspan: 2,
                colspan: 1
                };
            }else if(rowIndex === 28){
                return {
                rowspan: 2,
                colspan: 1
                };
            }else if(rowIndex === 30){
                return {
                rowspan: 2,
                colspan: 1
                };
            }else if(rowIndex === 32){
                return {
                rowspan: 2,
                colspan: 1
                };
            }else{
                return {
                    rowspan: 1,
                    colspan: 1
                }
            }
            }; 
      },
        
        // rules: {
        //     name: [
        //     { required: true, message: '请输入项目名称', trigger: 'blur' },
        //     ],
        // }
      }
    }

</script>


